import createAction from './create-action'
import { ProductStoreType } from '@types'

import {
  ADD_PRODUCTS_STORES,
  REMOVE_PRODUCTS_STORES,
  UPDATE_PRODUCTS_STORES,
  UPDATE_PRODUCTS_STORES_PRICE,
} from '../action-list'

export type ProductsStoresScope = { productId: number } | { storeId: number }

/**
 * Replaces every row in "scope" of store or product with the fetched payload.
 */
export const updateProductsStores = createAction(
  UPDATE_PRODUCTS_STORES,
  (productsStores: ProductStoreType[], scope: ProductsStoresScope) => ({
    payload: { productsStores, scope },
  }),
)
/**
 * To only add ProductsStores records
 */
export const addProductsStores =
  createAction<ProductStoreType[]>(ADD_PRODUCTS_STORES)

export const removeProductsStores = createAction<ProductStoreType[]>(
  REMOVE_PRODUCTS_STORES,
)
export const updateProductsStoresPrice = createAction(
  UPDATE_PRODUCTS_STORES_PRICE,
)
